import Layout from "@/components/Layout/Layout";
import ResourcesLayout from "./ResourcesLayout";
import VideoCard from "./VideoCard";
import Video from "./Video";
import { useState } from "react";

export default function Videos({ section, data, close, index_locators, white }) {
    const [selectedVideo, setSelectedVideo] = useState(null);

    if (selectedVideo) return <Video
        videoUrl={selectedVideo.videoUrl}
        subtitlesUrl={selectedVideo.subtitlesUrl}
        title={selectedVideo.title}
        close={() => setSelectedVideo(null)}
    />;

    return (
        <Layout section={section}>
            <ResourcesLayout data={data} close={close} white={white}>
                <ul className="area-card--audiovisuals link-dn">
                    {index_locators.map((locator) => {
                        const key = locator.section_id + locator.tag_id;
                        return (
                            <VideoCard key={key} locator={locator} selectVideo={setSelectedVideo}/>
                        )
                    })}
                </ul>
            </ResourcesLayout>
        </Layout>
    )
}